<template>
  <div class="h-100">
    <div class="loader-cont" v-dxloader="isLoader"></div>
    <div class="row h-100" v-show="!isLoader">
      <div class="content-wrapper-before gradient-45deg-indigo-purple"></div>
      <div class="breadcrumbs-dark pb-0 pt-4" id="breadcrumbs-wrapper">
        <!-- Search for small screen-->
        <div class="container">
          <div class="row">
            <div class="col s10 m6 l6 alignLeft">
              <h5 class="card-title alignLeft white-text">Services</h5>
            </div>
            <div class="col s10 m6 l6 alignRight">
              <a
                @click="preAddCategory()"
                data-target="modal-service"
                class="btn modal-trigger add_btn mb-1 waves-effect waves-light"
              >
                <span>Add Category</span>
              </a>
            </div>
          </div>
        </div>
      </div>
      <div class="col s12 p-0" style="height:calc(100% - 52px)">
        <div class="container p-0 h-100">
          <div class="section p-0 h-100">
            <div class="row m-0 h-100">
              <div class="col s12 m12 l12 p-0 h-100">
                <div id="responsive-table" class="card card card-default scrollspy mb-0 h-100">
                  <div class="card-content h-100">
                    <div class="row">
                      <div class="search-input col s8 m5 l5">
                        <div class="sidebar-search animate fadeUp">
                          <div class="search-area">
                            <i class="material-icons mr-2 search-icon">search</i>
                            <i
                              class="material-icons mr-2 close-icon"
                              v-show="filters.search"
                              @click="filters.search=''"
                            >close</i>
                            <input
                              type="text"
                              v-model="filters.search"
                              placeholder="Search"
                              class="app-filter"
                              id="chat_filter"
                            />
                          </div>
                        </div>
                      </div>
                    </div>
                    <div class="row mt-2" style="height: calc(100% - 100px);overflow-y: auto">
                      <div class="col s12 servicecat h-100">
                        <table class="responsive-table" v-if="categoryList.length > 0">
                          <thead>
                            <tr>
                              <th data-field="index">S.No</th>
                              <th data-field="id">Category Name</th>
                              <th data-field="created_at">Created On</th>
                              <th data-field="updated_at">Last Modified</th>
                              <th data-field="status">Action</th>
                            </tr>
                          </thead>
                          <tbody>
                            <tr v-for="(item,index) in categoryList" :key="item.id">
                              <td>{{index + 1}}</td>
                              <td>{{item.name}}</td>
                              <td>{{item.created_at | date('DD MMM YY, hh:mm a')}}</td>
                              <td>{{item.last_modified | date('DD MMM YY, hh:mm a')}}</td>
                              <td>
                                <a
                                  @click="updateCategory(item)"
                                  data-target="modal-service"
                                  class="modal-trigger btn-floating mb-1 waves-effect waves-light"
                                >
                                  <i class="material-icons">edit</i>
                                </a>
                              </td>
                            </tr>
                          </tbody>
                        </table>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div id="modal-service" class="modal mo-40">
      <div class="modal-header header_br">
        <h6 class="alignLeft">{{isEdit ? 'Update' : 'Add'}} Service Category</h6>
      </div>
      <form class="login-form">
        <div class="modal-content">
          <div class="row">
            <div class="col s12 m12 l12">
              <div class="row margin">
                <div class="input-field col s12">
                  <!-- <i class="material-icons prefix pt-2">dns</i> -->
                  <input
                    v-model="currCategory.name"
                    @keyup="errorMessage=''"
                    id="category"
                    name="category"
                    type="text"
                  />
                  <label for="category" class="center-align">Category Name</label>
                  <div class="error-message" v-if="errorMessage">{{errorMessage}}</div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="modal-footer">
          <a class="modal-action modal-close waves-effect btn-flat">Cancel</a>
          <button
            v-loader-button="isLoading"
            type="submit"
            name="action"
            class="pointer waves-effect btn"
          >Save</button>
        </div>
      </form>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      categoryList: [],
      isEdit: false,
      isLoading: false,
      currCategory: {},
      Validator: {},
      errorMessage: "",
      isLoader: true,
      filters: {
        search: ""
      }
    };
  },
  created() {
    setTimeout(() => {
      $(".modal").modal({ dismissible: false });
    }, 500);

    setTimeout(() => {
      this.Validator = $(".login-form").validate({
        rules: {
          category: {
            required: true
          }
        },
        //For custom messages
        messages: {
          category: {
            required: "Category Name is required"
          }
        },
        errorElement: "div",
        errorPlacement: function(error, element) {
          var placement = $(element).data("error");
          if (placement) {
            $(placement).append(error);
          } else {
            error.insertAfter(element);
          }
        },
        submitHandler: e => {
          $("button").attr("disabled", "disabled");
          setTimeout(() => {
            $("button").removeAttr("disabled");
          }, 500);
          if (this.errorMessage == "") {
            if (this.isEdit) this.confirmUpdateCategory();
            else this.addCategory();
          }
          return false;
        }
      });
    }, 500);
    this.listCategories();
  },
  methods: {
    listCategories(url = Constants.default.APIURL.ServiceCategory) {
      ajax.get(
        url,
        res => {
          this.categoryList = res.data;
          if (this.categoryList.length == 0) {
            Vue.showNoDataBlock(".servicecat");
          } else {
            Vue.hideNoDataBlock(".servicecat");
          }
          this.isLoader = false;
        },
        err => {
          this.isLoader = false;
        }
      );
    },
    updateCategory(item) {
      setTimeout(function() { $('input[name="category"]').focus() }, 50);
      this.isEdit = true;
      this.currCategory = JSON.parse(JSON.stringify(item));
      this.errorMessage = "";
      setTimeout(() => {
        this.Validator.resetForm();
        M.updateTextFields();
      }, 100);
    },
    preAddCategory() {
      setTimeout(function() { $('input[name="category"]').focus() }, 50);
      this.currCategory = {};
      this.isEdit = false;
      this.errorMessage = "";
      setTimeout(() => {
        this.Validator.resetForm();
        M.updateTextFields();
      }, 100);
    },
    addCategory() {
      return new Promise((resolve, reject) => {
        this.isLoading = true;
        ajax.post(
          Constants.default.APIURL.ServiceCategory,
          {
            name: this.currCategory.name
          },
          res => {
            Vue.toast("Service Category was added sucessfully.");
            $(".modal").modal("close");
            this.isLoading = false;
            this.listCategories();
            resolve();
          },
          err => {
            reject();
            this.isLoading = false;
            this.errorMessage = Vue.errorHandler(err);
          }
        );
      });
    },
    confirmUpdateCategory() {
      return new Promise((resolve, reject) => {
        this.isLoading = true;
        ajax.patch(
          Constants.default.APIURL.ServiceCategory + this.currCategory.id + "/",
          {
            name: this.currCategory.name
          },
          res => {
            Vue.toast("Service Category was updated sucessfully.");
            $(".modal").modal("close");
            this.listCategories();
            this.isLoading = false;
            resolve();
          },
          err => {
            reject();
            this.isLoading = false;
            this.errorMessage = Vue.errorHandler(err);
          }
        );
      });
    },
    searchFilter(filter) {
      let url = Constants.default.APIURL.ServiceCategory;
      url += filter.search ? "?q=" + filter.search : "";
      this.listCategories(url);
    }
  },
  watch: {
    filters: {
      handler: function() {
        this.searchFilter(this.filters);
      },
      deep: true
    }
  }
};
</script>

<style lang="scss" scoped>
.add_category {
  float: right;
}

.btn-floating {
  color: #212121;
  background: white !important;
}

.card .card-title {
  font-size: 22px;
  font-weight: 600;
  margin-bottom: 20px;
}

.btn-floating i {
  color: #212121;
}

.error-message {
  text-align: right;
  margin-top: 0 !important;
  margin-bottom: 0 !important;
}

a.add_btn {
  margin-top: 10px;
  margin-right: 10px;
  span {
    display: flex;
    align-items: center;
    justify-content: center;
  }
}
.search-input {
  .sidebar-search {
    display: -webkit-box;
    display: -webkit-flex;
    display: -moz-box;
    display: -ms-flexbox;
    display: flex;
    padding: 0 0 1rem 0;
    -webkit-box-pack: justify;
    -webkit-justify-content: space-between;
    -moz-box-pack: justify;
    -ms-flex-pack: justify;
    justify-content: space-between;
    -webkit-box-align: center;
    -webkit-align-items: center;
    -moz-box-align: center;
    -ms-flex-align: center;
    align-items: center;
  }
  .search-area {
    display: -webkit-box;
    display: -webkit-flex;
    display: -moz-box;
    display: -ms-flexbox;
    display: flex;
    width: -webkit-calc(100% - 0rem);
    width: -moz-calc(100% - 0rem);
    width: calc(100% - 0rem);
    -webkit-box-align: center;
    -webkit-align-items: center;
    -moz-box-align: center;
    -ms-flex-align: center;
    align-items: center;
  }
  i {
    font-size: 1.45rem;
    height: 41px;
    margin-right: 0 !important;
    padding: 0.75rem 0.25rem 0.35rem 0.75rem;
    color: #9e9e9e;
    border-radius: 5px;
    border-top-right-radius: 0;
    border-bottom-right-radius: 0;
    background-color: #eceff1;
  }
  .app-filter {
    height: 35px;
    margin-bottom: 0;
    padding: 0.2rem;
    color: #9e9e9e;
    border: none;
    border-radius: 5px;
    border-top-left-radius: 0;
    border-bottom-left-radius: 0;
    background-color: #eceff1;
    -webkit-box-flex: 1;
    -webkit-flex: 1;
    -moz-box-flex: 1;
    -ms-flex: 1;
    flex: 1;
    border-bottom: 0 !important;
    box-shadow: none !important;
  }
}
.search-area {
  i.close-icon {
    position: absolute;
    right: 10px;
    cursor: pointer;
    font-size: 18px;
    top: 22px;
    height: inherit;
    padding: 0;
    line-height: 0;
  }
}
</style>

